"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgBeachLine1 = function SvgBeachLine1(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.099 3.099c1.275-1.275 3.826-1.275 8.926-1.275 5.101 0 7.652 0 8.927 1.275 1.275 1.275 1.275 3.826 1.275 8.926 0 10.202 0 10.202-10.202 10.202-5.1 0-7.65 0-8.926-1.275-1.275-1.275-1.275-3.826-1.275-8.927 0-5.1 0-7.65 1.275-8.926Zm13.843 11.182v-4.174H14.9c-1.034 0-1.657.493-1.657 1.427 0 .648.312 1.083.87 1.271l-.96 1.476h1.107l.87-1.36h.762v1.36h1.05Zm-1.05-3.378v1.255h-.828c-.484 0-.787-.18-.787-.624 0-.45.32-.631.787-.631h.828Zm-5.712 1.443v-.902h2.378v.902H10.18ZM9.117 8.541H8.06l-1.263.935v.992l1.263-.935v4.748h1.057v-5.74Z",
    fill: "#000"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgBeachLine1);
var _default = exports["default"] = Memo;